import Title from "@components/common/Title";
import React from "react";
import Button from "@components/common/Button";
import Link from "@components/common/Link";
import { NavigationResponseModel } from "@models/layout";
import NavItem from "@components/common/Layout/NavItem";
import BreadCrumbs from "@components/common/BreadCrumbs";
export interface WebinarHeroPropsModel {
  title?: string;
  bigHeader?: string;
  ctaLink: string | undefined;
  ctaText?: string;
  description?: string;
  secondaryNav?: NavigationResponseModel;
  path?: string;
}
const WebinarHero: React.FunctionComponent<WebinarHeroPropsModel> = ({
  title,
  bigHeader,
  ctaLink,
  description,
  ctaText = "WATCH WEBINAR",
  secondaryNav,
  path,
}) => {
  const mainHeaderDataObjects = secondaryNav?.items?.data ?? [];
  const renderSecondaryNavigation = () => {
    return (
      <ul className="hidden lg:flex gap-8 relative">
        {mainHeaderDataObjects?.map((oneMainHeaderDataObject) => {
          const { attributes } = oneMainHeaderDataObject ?? {};
          return (
            <NavItem
              navAttributes={attributes}
              key={oneMainHeaderDataObject.id}
              topOffset={28}
            />
          );
        })}
      </ul>
    );
  };
  return (
    <div className="px-4 py-8 md:px-20 xl:px-[140px]  pb-[50px]  md:pb-20 items-center bg-dark-purple-50">
      <div className="flex justify-between text-white pb-10">
        <div>
          <BreadCrumbs path={path ?? ""} appendToPath="" />
        </div>
        <div>{renderSecondaryNavigation()}</div>
      </div>
      {title && (
        <Title
          variant="h3"
          titleText={title}
          className="text-primary-orange-50 text-center"
        />
      )}
      {bigHeader && (
        <Title
          titleText={bigHeader}
          variant="primary"
          className="px-[10%] text-white text-center xl:text-center max-w-none xl:max-w-none"
        />
      )}
      {description && (
        <Title
          titleText={description}
          variant="paragraph"
          className="px-[10%] text-white text-center xl:text-center mt-[22px] md:max-w-[80%] xl:max-w-[60%] mx-auto"
        />
      )}
      <Button className="mx-auto mt-8 xl:mt-12 !p-0 !h-auto">
        <Link
          href={ctaLink ?? "#"}
          linkText={ctaText}
          wrapperClassName=""
          className="no-underline px-10 py-3 block hover:font-normal"
          style={{ color: "inherit" }}
        />
      </Button>
    </div>
  );
};
export default WebinarHero;
